import appStore from '../utils/state';

export default class EmptyCart extends HTMLElement {
  private button: HTMLButtonElement | null = null;

  private onButtonClickBound = this.onButtonClick.bind(this);

  connectedCallback(): void {
    this.button = this.querySelector('[data-empty-cart-ref="button"]');

    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onButtonClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onButtonClickBound);
    }
  }

  onButtonClick(): void {
    appStore.actions.closeCartModal();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('empty-cart', EmptyCart);
